/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Segment_EventsInputs */

const en_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment Events`)
};

const fr_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmenter les événements`)
};

const de_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentereignisse`)
};

const it_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi del segmento`)
};

const ru_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События сегмента`)
};

const es_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de segmento`)
};

const zh_cn2_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细分事件`)
};

const ja_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントイベント`)
};

const hi_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड घटनाएँ`)
};

const pt_pt2_event_group_options_segment_events = /** @type {(inputs: Event_Group_Options_Segment_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos do Segmento`)
};

/**
* | output |
* | --- |
* | "Segment Events" |
*
* @param {Event_Group_Options_Segment_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_segment_events = /** @type {((inputs?: Event_Group_Options_Segment_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Segment_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_segment_events(inputs)
	if (locale === "de") return de_event_group_options_segment_events(inputs)
	if (locale === "it") return it_event_group_options_segment_events(inputs)
	if (locale === "ru") return ru_event_group_options_segment_events(inputs)
	if (locale === "es") return es_event_group_options_segment_events(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_segment_events(inputs)
	if (locale === "ja") return ja_event_group_options_segment_events(inputs)
	if (locale === "hi") return hi_event_group_options_segment_events(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_segment_events(inputs)
	return en_event_group_options_segment_events(inputs)
});